/* global modForm */
import { initBackButtons, initNextButtonAbusePrevention, initFormSubmit } from '../../helpers';
import { opts, additionalOptions } from '../../config';

export function removeEvents() {
	Object.assign(modForm, opts, additionalOptions);
	initFormSubmit(false);
	initBackButtons(false);
	initNextButtonAbusePrevention(false);
}
